import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Device, Carousel } from '@beef/smart-kit';
import { useDispatch, useSelector } from 'react-redux';

import commonStyles from 'styles/common.pcss';
import { getCookie } from 'utils/cookie';
import { sizeToNumber } from 'utils/formatting';
import { addToBasketCrossSell } from 'store/ProductDetails/crossSellProducts/actions';
import {
  isScreenBelow1004,
  isScreenBelow640,
  isScreenBelow800,
  isScreenBelow502,
} from 'store/common/settings/breakpoint/selectors';
import { SharedZoneBlocks, SharedZoneSliderBlocks } from 'store/SharedZone/blocks/selectors';
// import { SharedZoneSliderProductsContext } from 'store/SharedZone/blocks/contexts';
import { getSliderAsyncData, onViewSlider, onMoveSlider } from 'store/SharedZone/actions';
import { CROSSSELL_MEDIUM, CROSSSELL_SMALL, CROSSSELL_TINY } from 'bricks/CrossSell/constants';
import { SOURCES_NAMES, SOURCES } from 'store/common/basket/constants';
import { MAIN_PAGE_PATHNAME, BRAND_ZONE_PATHNAME } from 'store/SharedZone/constants';
/* import { ViewContainer, ProductSlider } from 'bricks';

import ProductSliderTile from './ProductSliderTile';
import BlockHeading from './components/BlockHeading';
import BlockMoreLink from './components/BlockMoreLink'; */

import { DeviceBlock } from './components/DeviceBlock';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

export const IconArrow = React.memo(() => (
  <svg fill="none" height={14} width={8} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.95 7L0 2.05 1.414.636 7.778 7l-6.364 6.364L0 11.95 4.95 7z" fill="#fff" />
  </svg>
));

/* const mapToRecomendations = (productList, dispatch) => {
  // TODO make common component
  const redirectToBasket = () => {
    window.location.href = '/basket/';
  };

  // eslint-disable-next-line consistent-return
  const getDiscount = (price, oldPrice) => {
    if (oldPrice) {
      return Math.floor((((oldPrice - price) * 100) / oldPrice));
    }
  };

  // eslint-disable-next-line consistent-return
  const getBadges = (badges) => {
    if (badges) {
      return badges.map((badge) => ({
        caption: badge.title,
        help: badge.displayText,
        backgroundColor: badge.color,
        src: badge.image,
      }));
    }
  };


  const res = productList.map(product => {
    const onOpenModal = () => {};

    const onClick = product?.isInBasket ? redirectToBasket : () => {
      onAddDevice(product?.productId, productList, dispatch);
    };

    const purchaseDataTitle = product?.isInBasket ? 'В корзине' : 'В корзину';
    const variant = product?.isInBasket ? 'secondary' : 'tertiary';

    const discount = getDiscount(product?.price?.value, product?.price?.oldValue);
    const isSamePrice = product?.price?.value === product?.price?.oldValue;

    return {
      onOpenModal,
      isWithModal: true,
      purchaseData: {
        variant,
        title: purchaseDataTitle,
        onClick,
      },
      device: {
        reviews: {
          count: product?.feedback?.count,
          average: product?.feedback?.average,
          link: `shop/details/${product?.slug}/otzyvy/`,
        },
        promoBadges: getBadges(product?.badges),
        slug: product?.url,
        id: product?.productId,
        imgOptions: {
          src: product?.imageUrl,
        },
        name: product?.title,
        price: product?.price?.value,
        oldPrice: !isSamePrice && product?.price?.oldValue,
        discount: !isSamePrice && discount,
        link: `shop/details/${product?.slug}`,
      },
    };
  });

  return res;
}; */

export const SliderBlockLayout = ({
  /* productIds,
  size,
  sizeNumber, */
  isMobile,
  /* hasMoreLink,
  className,
  onView,
  onMove, */
  productList,
  listHeading,
  /* blockId,
  position,
  gutter, */
  prevRef,
  nextRef,
  dispatch,
  requestData,
  setList,
  blockId,
}) => {
  /* componentDidMount() {
    // if data in the slider is loaded asynch (on mainpage)
    const { requestData, setList, blockId } = this.props;
    if (requestData) {
      const requestUrl = requestData.url || '';
      const requestParams = {};
      requestData.params.forEach(({ name, value }) => {
        requestParams[name] = value;
      });
      setList(blockId, requestUrl, requestParams);
    }
  } */

  const [canRender, setCanRender] = useState(false);
  const [numSlides, setNumSlides] = useState(4);
  const [sliderWidth, setSliderWidth] = useState('100%');
  const [sliderWidthMobile, setSliderWidthMobile] = useState('100%');

  useEffect(() => {
    // if data in the slider is loaded asynch (on mainpage)

    if (requestData) {
      const requestUrl = requestData.url || '';
      const requestParams = {};
      requestData.params.forEach(({ name, value }) => {
        requestParams[name] = value;
      });
      setList(blockId, requestUrl, requestParams);
    }
  }, []);

  useEffect(() => {
    setCanRender(false);

    if (productList.length > 0) {
      if (isMobile && productList.length > 1) {
        setNumSlides(2);
      } else if (isMobile) {
        setNumSlides(1);
        setSliderWidthMobile('50%');
      } else if (!isMobile && productList.length > 3) {
        setNumSlides(4);
      } else {
        setNumSlides(productList.length);
        setSliderWidth(`${(productList.length / 5) * 100 + 2}%`);
      }
      setCanRender(true);
    }
  }, [productList]);

  // eslint-disable-next-line no-unused-vars
  const getSourceForCurrentPathname = () => {
    if (typeof window !== 'undefined') {
      const currentPathname = window.location.pathname;
      if (currentPathname.includes(BRAND_ZONE_PATHNAME)) {
        return SOURCES_NAMES.BRAND_ZONE_PAGE;
      } else if (currentPathname.includes(MAIN_PAGE_PATHNAME)) {
        return SOURCES_NAMES.SHOP_MAIN_PAGE;
      }
    }
    return undefined;
  };

  const settings1 = {
    onInit: (swiper) => {
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
    },
    resizeObserver: true,
    pagination: {
      clickable: true,
      loop: true,
    },
    spaceBetween: 16,
    slidesPerGroup: numSlides > 0 ? numSlides : 4,
    slidesPerView: numSlides > 0 ? numSlides : 4,
  };

  return (productList || []).length ?
      <>
        <div className={cx('CarouselWrap', isMobile && 'mobile')}>
          <div className={cx('title', isMobile && 'mobile')}>{listHeading}</div>
          {canRender && (
            <div
              className={cx('innerWrapper')}
              style={{ width: !isMobile ? sliderWidth : sliderWidthMobile }}
            >
              {productList.length > 4 && !isMobile && (
                <div className={cx('wrapper-nav')}>
                  <button
                    ref={nextRef}
                    className={cx('next-nav', 'nav')}
                    type="button"
                    name="Вперед"
                  >
                    <IconArrow />
                  </button>
                  <button
                    ref={prevRef}
                    className={cx('prev-nav', 'nav')}
                    type="button"
                    name="Назад"
                  >
                    <IconArrow />
                  </button>
                </div>
              )}
              <Carousel settings={settings1}>
                {productList.map((product) => (
                  <div key={product?.productId}>
                    <DeviceBlock product={product} isMobile={isMobile} />
                  </div>
                ))}
              </Carousel>
            </div>
          )}
        </div>
        {/*
        <ViewContainer
          onView={() => { onView(productList, sizeNumber, listHeading, blockId); }}
        >
          <div className={cx('component', { mobile: isMobile }, className)}>
            <BlockHeading className={cx(hasMoreLink ? 'marb-s' : 'marb-l', 'center', 'headline')} />
            <BlockMoreLink className={cx('marb-l', 'center')} />
            <ProductSlider
              className={cx(isMobile && 'mobileContainer')}
              size={size}
              isMobile={isMobile}
              onStart={(start) => { onMove(productList, sizeNumber, start, blockId, position); }}
              gutter={gutter}
            >
              {productList.map(product => (
                <Device
                  className={cx('deviceItem', isMobile && 'mobile')}
                  onOpenModal={() => {}}
                  purchaseData={getPurchaseData(product)}
                  device={getDeviceData(product)}
                  isWithModal
                />
              ))}
            </ProductSlider>
          </div>
              </ViewContainer>
              */}
      </>
    : null;
};

SliderBlockLayout.defaultProps = {
  // gutter: 1,
};

SliderBlockLayout.propTypes = {
  // productIds: PropTypes.arrayOf(PropTypes.string),
  productList: PropTypes.array,
  listHeading: PropTypes.string,
  /* size: PropTypes.oneOf([CROSSSELL_TINY, CROSSSELL_MEDIUM, CROSSSELL_SMALL]),
  sizeNumber: PropTypes.number, */
  isMobile: PropTypes.bool,
  /* hasMoreLink: PropTypes.bool,
  className: PropTypes.string,
  onView: PropTypes.func,
  onMove: PropTypes.func, */
  requestData: PropTypes.object,
  setList: PropTypes.func,
  blockId: PropTypes.string,
  /* position: PropTypes.number,
  gutter: PropTypes.number, */
  prevRef: PropTypes.object,
  nextRef: PropTypes.object,
  dispatch: PropTypes.func,
};

/**
 * local selector for resolution,
 * isolated into a function to keep mapStateToProps clean
 */
const getSliderSize = (state) => {
  if (isScreenBelow502(state)) return CROSSSELL_TINY;
  if (isScreenBelow800(state)) return CROSSSELL_SMALL;
  if (isScreenBelow1004(state)) return CROSSSELL_MEDIUM;
  return null;
};

const getSliderSizeNumber = (state) => {
  const size = getSliderSize(state);
  return sizeToNumber(size);
};

const mapStateToProps = (state) => ({
  size: getSliderSize(state),
  sizeNumber: getSliderSizeNumber(state),
  isMobile: isScreenBelow640(state),
  hasMoreLink: SharedZoneSliderBlocks.getBlockHasReferenceText(state),
  productIds: SharedZoneSliderBlocks.getProductIdsList(state),
  productList: SharedZoneSliderBlocks.getProductList(state),
  listHeading: SharedZoneBlocks.getHeadline(state),
  requestData: SharedZoneSliderBlocks.getProductRequestData(state),
  position: SharedZoneSliderBlocks.getPosition(state),
  blockId: SharedZoneBlocks.getId(state),
});

const mapDispatchToProps = {
  setList: getSliderAsyncData,
  onView: onViewSlider,
  onMove: onMoveSlider,
};

function withHooks(ComponentToAddHooks) {
  return function WrappedComponent(props) {
    const dispatch = useDispatch();
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    return (
      <ComponentToAddHooks {...props} dispatch={dispatch} prevRef={prevRef} nextRef={nextRef} />
    );
  };
}

export default withHooks(
  SharedZoneBlocks.connect(mapStateToProps, mapDispatchToProps)(SliderBlockLayout),
);
